import { upperFirst } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CAPACITY_UNITS } from 'modules/attendance/lib/enums'

enum UnitsOptions {
  capacity = 'capacity',
  threshold = 'threshold',
}

const handleCapacityUnitsI18n = (frequency: string, type = UnitsOptions.capacity): string => {
  if (frequency === CAPACITY_UNITS.minutes) {
    if (type === UnitsOptions.capacity)
      return upperFirst(
        i18n.t(
          'time_tracking.settings.overtime.compensation.timeoff.form.fields.capacity_units.minutes'
        )
      )

    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.threshold_units.minutes'
      )
    )
  }

  if (type === UnitsOptions.capacity)
    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.capacity_units.hours'
      )
    )

  return upperFirst(
    i18n.t('time_tracking.settings.overtime.compensation.timeoff.form.fields.threshold_units.hours')
  )
}

export const capacityUnitsOptions = () => {
  const capacityUnitsKeys = Object.keys(CAPACITY_UNITS)

  return capacityUnitsKeys.map((capacity) => ({
    label: handleCapacityUnitsI18n(capacity),
    value: capacity,
  }))
}

export const thresholdUnitsOptions = () => {
  const capacityUnitsKeys = Object.keys(CAPACITY_UNITS)

  return capacityUnitsKeys.map((capacity) => ({
    label: handleCapacityUnitsI18n(capacity, UnitsOptions.threshold),
    value: capacity,
  }))
}
